import { SpineAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { Renderer, AbstractRenderer, DisplayObject, RenderTexture, Sprite, SCALE_MODES, Matrix, Texture, BaseTexture } from "pixi.js";

export async function convertSpines(services: GameServices, spineSpecs: Record<string, SpineAssetSpec>) {
    const { factory } = services;
    const spineMap: Record<string, Spine> = {};
    Object.values(spineSpecs).forEach((spec) => spineMap[spec._key] = factory.createSpine(spec));
    Object.entries(spineMap).forEach(([key, spine]) => {
        if (key === `robin-hood`) {
            spine.skeleton.setToSetupPose();
            spine.skeleton.setSkinByName(`robin-hood-top`);
            spine.update(1);
            displayObjectToRenderTexture(services, `robin-hood-top`, spine);
            spine.skeleton.setSkinByName(`robin-hood-bottom`);
            spine.update(1);
            displayObjectToRenderTexture(services, `robin-hood-bottom`, spine);
        }
        else {
            spine.update(1);
            spine.skeleton.setToSetupPose();
            displayObjectToRenderTexture(services, key, spine);
        }
        spine.autoUpdate = false;
        spine.destroy();
    });
}

export function displayObjectToRenderTexture(services: GameServices, textureKey: string, displayObject: DisplayObject, format?: string, quality?: number) {

    const renderer = services.application.renderer;

    /**
     * Resolution of 2 is enough, higher the value more performance heavy it is.
     */
    const resolution = 2;
    /**
     * note: `_renderer.extract` doesn't work well with Sprite. Returns only transparent pixels. Instead,
         * we get image src from texture cache. Also, it's better for optimization.
         */
    let renderTexture: RenderTexture;
    if (displayObject instanceof Sprite && displayObject.children.length === 0) {
        renderTexture = RenderTexture.create({ scaleMode: SCALE_MODES.LINEAR, resolution, width: displayObject.width, height: displayObject.height });
        const t = displayObject.localTransform;
        const matrix = new Matrix(1, 0, 0, 1, -t.tx, -t.ty);
        renderer.render(displayObject, { renderTexture, transform: matrix });
    }
    else {
        renderTexture = renderer.generateTexture(displayObject, { scaleMode: SCALE_MODES.LINEAR, resolution });
    }

    services.resources.textures[textureKey] = renderTexture;

    return;
}